import { createContext, useContext, useState, ReactNode } from 'react'

interface WalletModalContextType {
  isOpen: boolean
  openModal: () => void
  closeModal: () => void
}

const WalletModalContext = createContext<WalletModalContextType | undefined>(undefined)

export function WalletModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  return (
    <WalletModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </WalletModalContext.Provider>
  )
}

export function useWalletModal() {
  const context = useContext(WalletModalContext)
  if (!context) {
    throw new Error('useWalletModal must be used within WalletModalProvider')
  }
  return context
}

